// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper-upload-form .label-blue[data-v-3135b1ae] {\n  color: #2b69bb;\n  font-weight: 500;\n}\n.sku-box-wrapper[data-v-3135b1ae] {\n  padding: 1em;\n  border-radius: 0.25rem;\n  border: 1px solid #e4eaec;\n}\n.sku-box-wrapper p[data-v-3135b1ae] {\n  margin-bottom: 0px;\n}\n.sku-box-action[data-v-3135b1ae] {\n  min-height: 65px;\n  margin-bottom: 0.5em;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}", ""]);
// Exports
module.exports = exports;
